import Head from 'next/head'
import MarketplaceHome from '@/components/TradlyHome/MarketplaceHome'

import TradlyFooter from '@/partials/TradlyFooter'
import AnyDevices from '@/components/home/tradly-home/AnyDevices'
import Integrations from '@/components/home/tradly-home/Integrations'
import Studio from '@/components/home/tradly-home/Studio'

import Cta from '@/partials/Cta'
import SuperAdmin from '@/components/Tradly/Fleet/SuperAdmin'
import Workspace from '@/components/Tradly/Fleet/Workspace'
import Editor from '@/components/Tradly/Fleet/Editor'
import FeatureHome from '@/components/Tradly/marketplace/FeatureHome'

export default function Home() {
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Free & Easy way to launch your marketplace Projects with no-code"
        />
        <meta 
        name="description" 
        content="Launch your marketplaces platforms without building from scratch. Free marketplace website templates, payment & marketing integrations, no-code marketplace builder, etc" 
        />
        <meta
          key="og:title"
          property="og:title"
          content="Simple & Easy way to launch your booking Portal & Website & App"
        />
        <title> Marketplace Software - Free & Easy way to launch your marketplace platforms with no-code</title>
      </Head>
      <div className="flex  flex-col min-h-screen overflow-hidden    ">
        <div className="flex-grow">
          <MarketplaceHome />
          <div className=" max-w-6xl mx-auto pt-20 mb-20 space-y-40 overflow-hidden sm:mb-32 md:mb-40">
            <FeatureHome />
            <SuperAdmin />
            <Workspace />
            <Editor />
            <Integrations />
            <AnyDevices />
            <Studio />
          </div>
          <Cta />

          <TradlyFooter />
        </div>
      </div>
    </>
  )
}
